import { useEffect, useRef, useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import { useFormContext, useWatch } from "react-hook-form";

const WitnessInformationFields = ({ isEdit, partiesData }) => {
  const {
    register,
    setValue,
    control,
    clearErrors,
    formState: { errors },
  } = useFormContext();

  const [selectedEntityLabel, setSelectedEntityLabel] = useState("Select Entity");
  const [selectedEntityIcon, setSelectedEntityIcon] = useState(null);
  const [isEntityDropdownOpen, setIsEntityDropdownOpen] = useState(false);
  const entityDropdownRef = useRef(null);
  const dateField = { setValueAs: (v) => (v === "" || v === null ? null : v) };
  const handleEntitySelection = (e, value, label, name, iconClass, _entityType) => {
    e.stopPropagation();
    setValue("witness_for_record_id", value); // Format: "EntityType,EntityId"
    setValue("witness_for_entity", label); // Store entity type separately if needed
    clearErrors("witness_for_record_id");
    setSelectedEntityLabel(name);
    setSelectedEntityIcon(iconClass);
    setIsEntityDropdownOpen(false);
  };

  const recordId = useWatch({ control, name: "witness_for_record_id" });
  const entityType = useWatch({ control, name: "witness_for_entity" });

  useEffect(() => {
    if (!recordId || !entityType || partiesData.length === 0) return;

    const match = partiesData.find(
      (p) => String(p.id) === String(recordId) && p.type === entityType
    );
    if (match) {
      setSelectedEntityLabel(match.name);
      setSelectedEntityIcon(getEntityIcon(match.type));
    }
  }, [recordId, entityType, partiesData]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (entityDropdownRef.current && !entityDropdownRef.current.contains(event.target)) {
        setIsEntityDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const handleEntityDropdownToggle = () => {
    setIsEntityDropdownOpen((prev) => !prev);
  };
  const getEntityIcon = (type) => {
    switch (type) {
      case "Client":
        return "ic-client";
      case "Defendant":
        return "ic-defendants";
      case "OtherParty":
        return "ic-parties";
      default:
        return "ic-client";
    }
  };

  return (
    <Row className="mx-0 p-l-5 p-r-5 m-t-5">
      <Col md={12} className="p-0">
        <div className="row mx-0 align-items-center custom-margin-bottom">
          <span className="d-inline-block white-space-nowrapping text-grey align-self-center m-r-5 defendant-input-label">
            Birthday:
          </span>
          <div className="d-flex-1">
            <input
              type="date"
              className="form-control p-l-5 p-0 height-25 rounded-0"
              {...register("witness_birthday", dateField)}
            />
          </div>
          <span className="d-inline-block p-l-5 white-space-nowrapping text-grey align-self-center m-r-5 defendant-input-label">
            Gender:
          </span>
          <div className="d-flex-1 custom-select-state-entity position-relative">
            <Form.Control
              as="select"
              className="form-control height-25 p-0 p-l-5 rounded-0"
              {...register("gender")}
            >
              <option value="">-----------</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
            </Form.Control>
          </div>
        </div>

        <div className="row mx-0 align-items-center custom-margin-bottom">
          <span className="d-inline-block white-space-nowrapping text-grey align-self-center m-r-5 defendant-input-label">
            SSN:
          </span>
          <div className="d-flex-1">
            <input
              type="text"
              placeholder="SSN"
              className="form-control p-l-5 p-0 height-25 rounded-0"
              {...register("ssn")}
            />
          </div>
          <span className="d-inline-block p-l-5 white-space-nowrapping text-grey align-self-center m-r-5 defendant-input-label">
            License Number:
          </span>
          <div className="d-flex-1">
            <input
              type="text"
              placeholder="Driver License Number"
              className="form-control p-l-5 p-0 height-25 rounded-0"
              {...register("driver_license")}
            />
          </div>
        </div>

        <div className="row mx-0 align-items-center custom-margin-bottom">
          <span className="d-inline-block white-space-nowrapping text-grey align-self-center m-r-5 defendant-input-label">
            Rep Letter:
          </span>
          <div className="d-flex-1">
            <input
              type="date"
              className="form-control p-l-5 p-0 height-25 rounded-0"
              {...register("RepLetterSent", dateField)}
            />
          </div>
          <span className="d-inline-block p-l-5 white-space-nowrapping text-grey align-self-center m-r-5 defendant-input-label">
            Contact:
          </span>
          <div className="d-flex-1">
            <input
              type="date"
              className="form-control p-l-5 p-0 height-25 rounded-0"
              {...register("contact_confirmed_date", dateField)}
            />
          </div>
        </div>

        {!isEdit && (
          <div className="row mx-0 align-items-center custom-margin-bottom">
            <span className="d-inline-block white-space-nowrapping text-grey align-self-center m-r-5 defendant-input-label">
              For:
            </span>
            <div className="d-flex-1 height-25">
              {/* <Form.Control
              as="select"
              className="form-select form-control p-l-5 p-0 height-25 rounded-0"
              value={selectedValue}
              onChange={handleForChange}
            >
              <option value=" ">-----------</option>
              {retainedByList?.clients?.map((client) => (
                <option key={`Client,${client.id}`} value={`Client,${client.id}`}>
                  {client.first_name} {client.last_name} (Client)
                </option>
              ))}
              {retainedByList?.defendants?.map((defendant) => (
                <option key={`Defendant,${defendant.id}`} value={`Defendant,${defendant.id}`}>
                  {defendant.entity_name ||
                    `${defendant.first_name || ""} ${defendant.last_name || ""}`.trim()}{" "}
                  (Defendant)
                </option>
              ))}
              {retainedByList?.otherParties?.map((party) => (
                <option key={`Other,${party.id}`} value={`Other,${party.id}`}>
                  {party.entity_name ||
                    `${party.party_first_name || ""} ${party.party_last_name || ""}`.trim()}{" "}
                  (Other Party)
                </option>
              ))}
            </Form.Control> */}
              <div className="ps-0 pe-0 custom-margin-bottom m-0">
                <div className="dropdown-container" ref={entityDropdownRef}>
                  <div
                    // className="height-25 p-0 rounded-0 form-control form-select d-flex align-items-center custom-select-state-entity"
                    className={`height-25 position-relative p-0 rounded-0 form-control d-flex align-items-center  custom-select-new-provider ${
                      errors.witness_for_record_id ? "is-invalid" : ""
                    }`}
                    onClick={handleEntityDropdownToggle}
                    style={{ padding: "0px", cursor: "pointer" }}
                  >
                    {selectedEntityIcon && (
                      <i className={`ic ic-19 ${selectedEntityIcon} m-r-5 m-l-5`} />
                    )}
                    <span style={{ paddingLeft: !selectedEntityIcon ? "5px" : "" }}>
                      {selectedEntityLabel}
                    </span>
                    {isEntityDropdownOpen && (
                      <ul
                        className="dropdown-list"
                        style={{
                          width: "638px",
                          top: "24px",
                          border: "1px solid #ced4da",
                          left: "-1px",
                        }}
                      >
                        {partiesData?.map((party, index) => {
                          const icon = getEntityIcon(party.type);
                          return (
                            <li
                              style={{ padding: "5px" }}
                              key={index}
                              onClick={(e) =>
                                handleEntitySelection(e, party.id, party.type, party.name, icon)
                              }
                            >
                              <i className={`ic ic-19 ${icon} m-r-5`} />
                              {party.name}
                            </li>
                          );
                        })}
                      </ul>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </Col>
    </Row>
  );
};

export default WitnessInformationFields;
